import {get, post} from "../../http";

const PATH = '/f2c/v1/admin';
const formUrl = (...endpoints) => [PATH, ...endpoints].join('/');
const urlFeaturesMerchant = (...endpoint) => formUrl('merchant-features', ...endpoint);
const urlFeaturesAccount = (...endpoint) => formUrl('account-features', ...endpoint);

export function apiAdminMerchantFeaturesList() {
  const url = urlFeaturesMerchant('list');
  return get(url);
}
export function apiAdminMerchantFeaturesUpdate(params) {
  const url = urlFeaturesMerchant('update');
  return post(url, params);
}
export function apiAdminAccountFeaturesList({id}) {
  const url = urlFeaturesAccount('list', id);
  return get(url);
}
export function apiAdminAccountFeaturesAdd(params) {
  const url = urlFeaturesAccount('add');
  return post(url, params);
}
export function apiAdminAccountFeaturesUpdate(params) {
  const url = urlFeaturesAccount('update');
  return post(url, params);
}
export function apiAdminAccountFeaturesDelete(params) {
  const url = urlFeaturesAccount('delete');
  return post(url, params);
}
